import omit from 'lodash/omit';
import {
  FETCH_ASSIGNMENT_DATA_SUCCESS,
  FETCH_ASSIGNMENT_DATA_FAILED,
  FETCH_ASSIGNMENT_DATA_START,
  FETCH_ASSIGNMENT_STUDENTS_STATUS_FAILED,
  FETCH_ASSIGNMENT_STUDENTS_STATUS_START,
  FETCH_ASSIGNMENT_STUDENTS_STATUS_SUCCESS,
  REMOVE_ASSIGNMENT_STUDENTS,
} from 'legacy/src/constants/types';

const teacherAssignmentInitialState = {
  assignment: {},
  submissionData: {},
  associatedResources: {},
  isFetching: false,
  errorMessage: null,
};

const teacherAssignment = (state = teacherAssignmentInitialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case FETCH_ASSIGNMENT_DATA_START:
      return {
        ...state,
        isFetching: true,
      };
    case FETCH_ASSIGNMENT_DATA_SUCCESS:
      return {
        ...state,
        ...payload,
        isFetching: false,
      };
    case FETCH_ASSIGNMENT_DATA_FAILED:
      return {
        ...state,
        ...payload,
        isFetching: false,
      };
    default:
      return state;
  }
};

const assignmentStudentsStatusInitialState = {
  assignmentStudentsStatusData: {},
  isFetching: false,
  errorMessage: '',
};

export const assignmentStudentsStatus = (
  state = assignmentStudentsStatusInitialState,
  action,
) => {
  const { type, payload } = action;
  switch (type) {
    case FETCH_ASSIGNMENT_STUDENTS_STATUS_START:
      const { isFetching } = payload;
      return {
        ...state,
        isFetching,
        assignmentStudentsStatusData: isFetching
          ? {}
          : state.assignmentStudentsStatusData,
      };
    case FETCH_ASSIGNMENT_STUDENTS_STATUS_SUCCESS:
      return {
        ...state,
        assignmentStudentsStatusData: {
          ...state.assignmentStudentsStatusData,
          ...payload,
        },
        isFetching: false,
      };
    case FETCH_ASSIGNMENT_STUDENTS_STATUS_FAILED:
      const { errorMessage } = payload;
      return {
        ...state,
        isFetching: false,
        errorMessage,
      };
    case REMOVE_ASSIGNMENT_STUDENTS:
      const { assignmentIds } = payload;
      return {
        ...state,
        assignmentStudentsStatusData: {
          ...omit(state.assignmentStudentsStatusData, assignmentIds),
        },
      };
    default:
      return state;
  }
};

export default teacherAssignment;
